<template>
  <a-card title="Dados de Consulta" class="card-custom">
    <div class="row">
      <div class="col-3">
        <label for="cpf">RG Militar</label>
        <div class="input-group input-focus">
          <input type="text" class="form-control form-input-component" ref="rgProfissonal" v-model="form.rgProfissional" id="rgProfissional" />
        </div>
      </div>

      <div class="col-3">
        <label for="cpf">CPF</label>
        <div class="input-group input-focus">
          <a-tooltip title="Necessário um cpf válido" placement="top">
            <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="form.cpf" id="cpf" />
          </a-tooltip>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <label>Nome completo</label>
          <div class="col" style="padding-right: 0">
            <div class="input-group input-focus">
              <a-auto-complete v-model:value="form.nome" style="width: 200px" @search="handleSearch" class="form-control">
                <template v-slot:dataSource>
                  <a-select-option v-for="item in profissionais" :key="item.nome" @click="onSelect(item)">
                    {{ item.nome }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </div>
          </div>

          <div class="col-sm-1 icon-button" style="margin: 2px 24px">
            <div @click="searchProfissional"><i class="fa fa-search"></i></div>
          </div>
          <div class="col-sm-1 icon-button" style="margin: 2px 24px">
            <span @click="clearForm"><i class="fa fa-eraser"></i></span>
          </div>
        </div>
      </div>
    </div>
  </a-card>

  <a-card title="Profissionais" class="card-custom">
    <div>
      <div class="row" v-if="naoEncontrado">
        <div class="col d-flex justify-content-center">
          <strong style="color: #1b70e7">Não foi encontrado nenhum profissional com os parâmetros informados.</strong>
        </div>
      </div>
      <a-table :dataSource="dataProfissionais" :columns="columns">
        <template #cpf="{ record }">
          <span>{{ formatarCpf(record.cpf) }}</span>
        </template>
        <template #action="{ record }">
          <a @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
        </template>
      </a-table>
      <br />
    </div>
  </a-card>

  <a-card class="card-custom">
    <div class="row">
      <div class="col d-flex justify-content-center">
        <button v-if="naoEncontrado && militar" @click="goToCreate('militar')" class="btn btn-primary" style="margin-right: 10px">Cadastrar Profissional Militar</button>
        <button v-if="naoEncontrado && terceirizado" @click="goToCreate('terceirizado')" class="btn btn-primary" style="margin-right: 10px">Cadastrar Profissional Terceirizado</button>
        <button class="btn btn-primary" style="margin-right: 10px" @click="this.$router.push({ path: '/home' })">Menu Principal</button>
      </div>
    </div>
  </a-card>
</template>

<script>
import { formatCpf, validarCpf } from '@/utils/servicos-utils';
import { getUserSicad } from '@/config/servicos-utils';
import { getProfissional } from '@/components/service/profissionalService';

export default {
  name: 'PageProfissional',
  data() {
    return {
      naoEncontrado: false,
      form: {
        rgProfissional: undefined,
        nome: undefined,
        cpf: undefined,
      },
      terceirizado: false,
      militar: false,
      dataProfissionais: [],
      profissionais: [],
      tooltipCpf: false,
      columns: [
        {
          title: 'Nome Completo',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'RG Militar',
          dataIndex: 'rgProfissional',
          key: 'rgProfissional',
        },
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
          slots: { customRender: 'cpf' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    goToCreate(type) {
      localStorage.setItem('cpf', this.form.cpf);
      this.$router.push('form-profissional-' + type);
    },
    clearForm() {
      this.form.rgProfissional = undefined;
      this.form.cpf = undefined;
      this.form.nome = undefined;
      this.dataProfissionais = [];
      this.naoEncontrado = false;
    },
    async searchProfissional() {
      await getProfissional(this.form).then((r) => {
        this.dataProfissionais = r.data.profissionais;
        if (this.dataProfissionais && this.dataProfissionais.length === 0) {
          this.naoEncontrado = true;
        } else {
          this.naoEncontrado = false;
        }
      });
    },
    formatarCpf(cpf) {
      return formatCpf(cpf);
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      this.tooltipCpf = false;
      if (value.length > 0 && !validarCpf(value)) {
        this.tooltipCpf = true;
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    editar(profissional) {
      if (profissional.vinculo === 'MILITAR') {
        this.$router.push({ path: '/form-profissional-militar/edit', query: { id: profissional.id } });
      } else {
        this.$router.push({ path: '/form-profissional-terceirizado/edit', query: { id: profissional.id } });
      }
    },
    async handleSearch(value) {
      value.length >= 3
        ? await getUserSicad({ nome: value }).then((r) => {
            this.profissionais = r.data;
          })
        : (this.profissionais = []);
    },
    onSelect(value) {
      this.form.nome = value.nome;
      this.form.cpf = value.cpf;
      this.form.rgProfissional = value.rgMilitar;
      if (value.vinculo === 'TERCEIRIZADO') {
        this.militar = false;
        this.terceirizado = true;
      } else if (value.vinculo === 'MILITAR') {
        this.militar = true;
        this.terceirizado = false;
      }
    },
  },
};
</script>

<style scoped>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}
</style>
